import Setting from "./index.vue";

export default {
  path: "setting",
  name: "SettingConfig",
  component: Setting,
  meta: {
    label: "配置项",
  },
};
